import { DateTime } from "luxon";
import { DataTableAction, DataTableField } from "@/components/data/data-table";
import { Reservation } from "@/swagger/models";
import { ReservationTableFilters, ReservationTableResult } from "./reservation-table-types";
import ReservationsTable from "@/components/tables/reservations/reservations-table.vue";

export const reservationTableFields = (): DataTableField<Reservation>[] => [
    { label: "User", field: "user", sortable: true },
    { label: "Office", field: "office", sortable: true },
    { label: "Floor", field: "floor", sortable: true },
    { label: "Zone", field: "zone", sortable: true },
    { label: "Desk", field: "desk", sortable: true },
    {
        label: "Date",
        field: "date",
        sortable: true,
        compact: true,
        format: (val, r): string => {
            const datetimeString = r.startAt ? `${r.date} ${r.startAt}` : r.date;
            return DateTime.fromSQL(datetimeString, { zone: "utc" })
                .toLocal()
                .toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
        },
    },
    {
        label: "Time",
        field: "time",
        sortable: true, // See Jira CIAO-506
        compact: true,
        format: (val, r): string => {
            if (!r.startAt) return "-";
            const startString = DateTime.fromSQL(`${r.date} ${r.startAt}`, { zone: "utc" })
                .toLocal()
                .toLocaleString(DateTime.TIME_24_SIMPLE);
            const endString = DateTime.fromSQL(`${r.date} ${r.endAt}`, { zone: "utc" })
                .toLocal()
                .toLocaleString(DateTime.TIME_24_SIMPLE);
            return `${startString} -  ${endString}`;
        },
    },
    {
        label: "Checkin",
        field: "checkin",
        sortable: false,
    },
    // { label: "Start time", field: "startAt", sortable: false },
    // { label: "End time", field: "endAt", sortable: false },

    // These two are false as typeORM does not handle case-sensitivity right in postgres..
    // { label: "Check-in", field: "checkinAt", sortable: false },
    // { label: "Check-out", field: "checkoutAt", sortable: false },
];

export const reservationTableActions = (context: ReservationsTable): DataTableAction<Reservation>[] => [
    {
        dataCy: "cancel_reservation",
        icon: "mdi-cancel",
        tooltip: "Cancel reservation",
        callback: (r) => {
            // @ts-ignore
            context.cancelReservation(r);
        },
    },
];

export const reservationTableFilters = (): ReservationTableFilters => ({
    page: 1,
    itemsPerPage: 20,
    sort: { field: "date", direction: 1 },
    dates: [DateTime.local().startOf("day"), DateTime.local().endOf("day")],
    customerId: null,
    officeId: null,
    floorId: null,
    zoneId: null,
    deskId: null,
    userId: null,
    checkin: null,
});

export const reservationTableResult = (): ReservationTableResult => ({
    reservations: [],
    total: 0,
    loading: false,
    offices: [],
    floors: [],
    zones: [],
    desks: [],
    users: [],
});
